import { createSlice } from '@reduxjs/toolkit';
import { logger } from 'services';
import { addProjectToTeam, removeProjectFromTeam, updateTeam } from 'utils/idb-utils';
import { MembershipsStore } from './models';
export const membershipsSlice = createSlice({
    name: '@@MEMBERSHIPS',
    initialState: MembershipsStore.empty(),
    reducers: (create)=>({
            setLoading: create.reducer((state, { payload: projectId })=>MembershipsStore.setLoading(projectId)(state)),
            setLoaded: create.reducer((state, { payload: { projectId, memberships, placeholders } })=>MembershipsStore.load(projectId, memberships, placeholders)(state)),
            setLoadedSeveral: create.reducer((state, { payload: loaded })=>loaded.reduce((store, { projectId, memberships, placeholders })=>MembershipsStore.load(projectId, memberships, placeholders)(store), state)),
            add: create.reducer((state, { payload: { projectId, memberships } })=>MembershipsStore.add(projectId, memberships)(state)),
            remove: create.reducer((state, { payload: { projectId, userIds } })=>MembershipsStore.remove(projectId, userIds)(state)),
            addProjectPlaceholder: create.reducer((state, { payload: { projectId, team } })=>{
                addProjectToTeam({
                    projectId: projectId[1],
                    teamId: team.teamId
                }).catch((err)=>{
                    logger.error(`Error occured while adding projectId to team. teamId: ${team === null || team === void 0 ? void 0 : team.teamId}`, err);
                });
                MembershipsStore.addProjectPlaceholder(projectId, team)(state);
            }),
            updateProjectPlaceholder: create.reducer((state, { payload: { projectId, team } })=>{
                updateTeam(team).catch((err)=>{
                    logger.error(`Error occured while updating team. teamId: ${team === null || team === void 0 ? void 0 : team.teamId}`, err);
                });
                MembershipsStore.updateProjectPlaceholder(projectId, team)(state);
            }),
            removeProjectPlaceholder: create.reducer((state, { payload: { projectId, teamId } })=>{
                removeProjectFromTeam({
                    projectId: projectId[1],
                    teamId
                }).catch((err)=>{
                    logger.error(`Error occured while removing projectId from team. teamId: ${teamId}`, err);
                });
                MembershipsStore.removeProjectPlaceholder(projectId, teamId)(state);
            })
        })
});
